import { creditDataPath } from '../constants';
import { OxfordHelpers } from '../Helpers';

export class UseCreditData {
  public static async getCreditDataRequest(token: string) {
    return OxfordHelpers.poll({
      method: 'GET',
      url: creditDataPath,
      token,
      jsonRequired: true,
    });
  }
}
